(function () {
  'use strict';

  var ACTION_ZONE_HEIGHT = 110;
  var MOBILE_MEDIA_QUERY = '(max-width: 749px)';
  var MAIN_ACTION_SELECTOR = [
    'main button',
    'main a.button',
    'main input[type="button"]',
    'main input[type="submit"]',
    'main [role="button"]'
  ].join(', ');
  var scheduled = false;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function viewportBounds() {
    var viewport = window.visualViewport;
    var top = viewport ? viewport.offsetTop : 0;
    var left = viewport ? viewport.offsetLeft : 0;
    var width = viewport ? viewport.width : window.innerWidth;
    var height = viewport ? viewport.height : window.innerHeight;

    return {
      top: top,
      right: left + width,
      bottom: top + height,
      left: left
    };
  }

  function isVisible(element, bounds) {
    if (!element) return false;
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(element);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.pointerEvents === 'none' ||
      Number(style.opacity) === 0
    ) return false;
    var rect = element.getBoundingClientRect();
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > bounds.left &&
      rect.left < bounds.right &&
      rect.bottom > bounds.top &&
      rect.top < bounds.bottom
    );
  }

  function isActionable(element, bounds) {
    if (element.disabled || element.getAttribute('aria-disabled') === 'true') return false;
    return isVisible(element, bounds);
  }

  function intersectsActionZone(element, bounds) {
    if (!isActionable(element, bounds)) return false;
    var rect = element.getBoundingClientRect();
    return rect.bottom > bounds.bottom - ACTION_ZONE_HEIGHT && rect.top < bounds.bottom;
  }

  function anyVisible(selector, bounds) {
    return Array.prototype.some.call(document.querySelectorAll(selector), function (element) {
      return isVisible(element, bounds);
    });
  }

  function updateCollisionState() {
    scheduled = false;
    var body = document.body;
    if (!body) return;

    var bounds = viewportBounds();
    var cartOpen = anyVisible(
      'cart-drawer.active, cart-drawer[open], .cart-drawer.active, .cart-drawer.is-open, #cart-notification.active',
      bounds
    );
    body.classList.toggle('nailhandy-cart-open', cartOpen);

    var isMobile = window.matchMedia(MOBILE_MEDIA_QUERY).matches;
    var footerVisible = isMobile && anyVisible(
      'footer, .footer, #shopify-section-footer',
      bounds
    );
    var purchaseUiActive = isMobile && anyVisible(
      '.sticky-atc, quick-add-modal[open], modal-dialog[open] product-form, [data-purchase-ui-active="true"]',
      bounds
    );
    var actionCollision = isMobile && Array.prototype.some.call(
      document.querySelectorAll(MAIN_ACTION_SELECTOR),
      function (element) {
        return intersectsActionZone(element, bounds);
      }
    );

    body.classList.toggle('nailhandy-purchase-ui-visible', purchaseUiActive);
    body.classList.toggle('nailhandy-widget-collision', actionCollision);
    body.classList.toggle('nailhandy-footer-visible', footerVisible);
  }

  function scheduleCollisionUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateCollisionState);
  }

  ready(function () {
    scheduleCollisionUpdate();
    window.addEventListener('scroll', scheduleCollisionUpdate, { passive: true });
    window.addEventListener('resize', scheduleCollisionUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleCollisionUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleCollisionUpdate);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', scheduleCollisionUpdate, { passive: true });
      window.visualViewport.addEventListener('resize', scheduleCollisionUpdate, { passive: true });
    }

    new MutationObserver(scheduleCollisionUpdate).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'hidden', 'style'],
      childList: true,
      subtree: true
    });
  });
})();
